import React, { useState, useEffect, useContext } from 'react'
import styled from 'styled-components'
import {
  getResultImpactType,
  getResultImpactTypeV2,
  addImpactType,
  updateImpactType,
  getTreeImpacttype,
  getTreeImpacttypeV2,
  getImpactTypeById,
  getDataCompanyV2,
} from 'api/MasterData/impactType'
import {
  Button,
  Drawer,
  Form,
  Row,
  Col,
  Input,
  Select,
  Table,
  Space,
  Alert,
  Modal,
  Switch,
} from 'antd'
//checkrole
import { CounterContext } from 'redux/Golbalvalues'
import { PlusOutlined, SearchOutlined, RedoOutlined } from '@ant-design/icons'
import iconEmpty from 'icons/createproject/supportneed.svg'
import DeleteImpactType from 'common/Management/delete'
import { getCookie } from 'helper/cookie'
import Tree from '../Tree/Company/TreeImpacttype'
import { toUpper } from 'lodash'
import lang from 'lang/en'
import FilterSearchTree from './FilterSearchTree'

const EmptyContainer = styled.div``
const ContainerImpactype = styled.div``
const Header = styled.div``
const Body = styled.div``
const TextTitleBold = styled.h2`
  font-family: 'IBMPlexSansThaiBold';
`
const initalState = {
  data: [],
  isLoading: true,
  company: 1,
  pagination: {
    pageSize: 10, // จำนวนข้อมูลในหน้านั้น
    total: 0, // ข้อมูลทั้งหมด
    current: 1,
    showQuickJumper: true,
    showSizeChanger: false, // ไม่ให้ผู้ใช้เปลี่ยนขนาดหน้า
    showTotal: (total, range) => showToalPagination(total, range),
  },
}
const showToalPagination = (total, range) => {
  return <p className="small-show-total">{`${range[0]}-${range[1]} of ${total}`}</p>
}
const ImpactContainer = styled.div``
const Impact = (props) => {
  // const { dataCompany } = props
  const token = getCookie('access_token_admin')
  const language = getCookie('lang')
  const word = lang[language]
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const [pagination, setPagination] = useState(initalState.pagination)
  const [data, setData] = useState(initalState.data)
  const [titleDrawer, setTitleDrawer] = useState('')
  const [stateDrawer, setStateDrawer] = useState('')
  const [visibleDelete, setVisibleDelete] = useState(false)
  const [dataEdit, setDataEdit] = useState()
  const [visible, setVisible] = useState(false)
  const [form] = Form.useForm()

  const [switchValue, setSwitchValue] = useState(true)

  // ตัวแปร tree
  const [dataTree, setDataTree] = useState(initalState.data)
  const [level, setLevel] = useState(1)
  const [level_ID, setLevel_ID] = useState(0)
  const [checkByID, setCheckByID] = useState()
  const [companyID, setCompanyID] = useState()
  const [checkChangeTable, setCheckChangeTable] = useState(0)

  //search
  const [searchedColumn, setSearchedColumn] = useState('')
  const [searchText, setSearchText] = useState('')
  // เช็คไอดีซ้ำ
  const [hiddenError, setHiddenError] = useState(true)

  //  เช็ค render ครั้งแรก
  const [firsttimein, setFirsttimein] = useState(true)

  const [wordERR, setWordERR] = useState('')

  //checkrole
  const { adminPermission } = useContext(CounterContext)
  //check permission
  const [disablePage, setDisablePage] = useState(false)

  // impact type tree select
  // ใช้สำหรับจัดการ impact type tree select

  const [dataCompany, setDataCompany] = useState([])
  const [filteredImpactTypes, setFilteredImpactTypes] = useState([])
  const [filterDataImpactType, setFilterDataImpactType] = useState([])
  const [filteredTreeImpactType, setFilteredTreeImpactType] = useState([])
  const [firstTimeFilter, setFirstTimeFilter] = useState(true)
  const textd = word['Impact_Type'] || 'Impact Types'

  const [permissionPage, setPermissionPage] = useState({
    create: false,
    read: false,
    update: false,
    delete: false,
  })

  const roleUser = getCookie('roleUser')
  useEffect(() => {
    if (roleUser == 1) {
      setPermissionPage((prevState) => ({
        ...prevState,
        create: true,
        read: true,
        update: true,
        delete: true,
      }))
    } else {
      adminPermission.map((item) => {
        if (item.menu_id == 14) {
          setPermissionPage((prevState) => ({
            ...prevState,
            create: item.create == 'Y' ? true : false,
            read: item.read == 'Y' ? true : false,
            update: item.update == 'Y' ? true : false,
            delete: item.delete == 'Y' ? true : false,
          }))
        }
      })
    }
  }, [adminPermission])

  useEffect(() => {
    if (filteredImpactTypes.length > 0) {
      const filteredTree = dataTree.filter(
        (item) =>
          filteredImpactTypes.includes(item.id) || filteredImpactTypes.includes(0),
      )
      setFilteredTreeImpactType(filteredTree)
      setCompanyID(filteredTree[0]?.id)
    } else {
      setFilteredTreeImpactType(dataTree)
      setCompanyID(dataTree[0]?.id)
    }
  }, [filteredImpactTypes, dataTree])

  useEffect(() => {
    if (companyID !== undefined) {
      getDataImpactype()
    }
  }, [companyID])

  //data company
  const getResultDataCompany = async () => {
    await getDataCompanyV2({
      token: token,
      level: level,
      level_id: level_ID,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          setDataCompany([])

          setIsLoading(false)
          return true
        }
        if (status === 200) {
          setDataCompany(data.result)
          setIsLoading(false)
        } else {
          setDataCompany([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  const getResultTreeImpacttype = async () => {
    try {
      const response = await getTreeImpacttypeV2({
        token: token,
      })

      const { status, data, error } = response
      if (error) {
        setDataTree([])
        setIsLoading(false)
        return false
      }

      if (status === 200) {
        setDataTree(data.result)
        // ไม่ต้องตั้งค่า companyID ที่นี่ เพราะจะตั้งค่าใน useEffect ข้างบน
        setIsLoading(false)
        return true
      } else {
        setDataTree([])
        setIsLoading(false)
        return false
      }
    } catch (error) {
      setDataTree([])
      setIsLoading(false)
      console.error(error)
      return false
    }
  }

  // const getDataImpactype = async () => {
  //   setIsLoading(true)

  //   try {
  //     const response = await getResultImpactType({
  //       company_id: companyID,
  //       token: token,
  //     })

  //     if (response.status === 200) {
  //       setData(response.data)

  //       // ตั้งค่า pagination ตามจำนวนข้อมูล
  //       if (response.data.length <= 10) {
  //         setPagination(false)
  //       } else {
  //         // สร้าง pagination object ใหม่โดยระบุ total ตามจำนวนข้อมูลทั้งหมด
  //         const paginationConfig = {
  //           ...initalState.pagination,
  //           total: response.data.length,
  //           current: 1, // รีเซ็ตกลับไปหน้าแรก
  //         }
  //         setPagination(paginationConfig)
  //       }
  //     } else {
  //       setData([])
  //     }
  //   } catch (error) {
  //     console.error('Error fetching impact type data:', error)
  //     setData([])
  //   } finally {
  //     setIsLoading(false)
  //   }
  // }

  const getDataImpactype = async () => {
    setIsLoading(true)

    try {
      const response = await getResultImpactTypeV2({
        company_id: companyID,
        token: token,
      })

      if (response.status === 200) {
        setData(response.data.result)

        // ตั้งค่า pagination ตามจำนวนข้อมูล
        if (response.data.length <= 10) {
          setPagination(false)
        } else {
          // สร้าง pagination object ใหม่โดยระบุ total ตามจำนวนข้อมูลทั้งหมด
          const paginationConfig = {
            ...initalState.pagination,
            total: response.data.length,
            current: 1, // รีเซ็ตกลับไปหน้าแรก
          }
          setPagination(paginationConfig)
        }
      } else {
        setData([])
      }
    } catch (error) {
      console.error('Error fetching impact type data:', error)
      setData([])
    } finally {
      setIsLoading(false)
    }
  }

  const getResultImpacttypeById = async () => {
    await getImpactTypeById({
      id: companyID,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setData([])

          setIsLoading(false)
          return true
        }
        if (status === 200) {
          let a = []
          a.push(data)
          setData(a)
          setIsLoading(false)
        } else {
          setData([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setData([])
        setIsLoading(false)
        console.error(error)
      })
  }

  // const getResultImpacttypeById = async () => {
  //   await getImpactTypeByIdV2({
  //     id: companyID,
  //     token: token,
  //   })
  //     .then(async (response) => {
  //       const { status, data, error } = response
  //       if (error) {
  //         setData([])

  //         setIsLoading(false)
  //         return true
  //       }
  //       if (status === 200) {
  //         let a = []
  //         a.push(data.result)
  //         setData(a)
  //         setIsLoading(false)
  //       } else {
  //         setData([])

  //         setIsLoading(false)
  //         return true
  //       }
  //     })
  //     .catch((error) => {
  //       setData([])
  //       setIsLoading(false)
  //       console.error(error)
  //     })
  // }

  useEffect(() => {
    if (token) {
      // เรียก getResultTreeImpacttype และตั้งค่า default company
      getResultTreeImpacttype().then(() => {
        if (dataTree && dataTree.length > 0 && firsttimein) {
          // ตรวจสอบว่ามีข้อมูลใน dataTree ก่อนตั้งค่า companyID
          setCompanyID(dataTree[0].id)
          // เรียกโดยใช้ setTimeout เพื่อให้แน่ใจว่า companyID ได้รับการอัพเดตแล้ว
          setTimeout(() => {
            getDataImpactype()
          }, 0)
          setFirsttimein(false)
        }
      })
      getResultDataCompany()
    }
  }, [token])

  useEffect(() => {
    if (checkChangeTable == 9998) {
      setCheckChangeTable(0)
      getDataImpactype()
    } else {
      getDataImpactype()
    }
  }, [checkChangeTable])
  // search
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            className="mini-search-btn-admin"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          >
            <SearchOutlined className="icon" />
            Search
          </Button>
          <Button
            type="primary"
            className="mini-search-btn-admin-reset"
            onClick={() => handleReset(clearFilters)}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
    render: (text) => (searchedColumn === dataIndex ? text : text),
  })
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm()
    setSearchText(selectedKeys[0])
    setSearchedColumn(dataIndex)
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }

  const renderTable = () => {
    // กำหนดข้อมูลที่จะแสดงตามเงื่อนไขการกรอง
    let displayData = data

    // ถ้าไม่ได้เลือก All แต่มีการกรอง
    // if (filteredImpactTypes.length > 0 && !filteredImpactTypes.includes(0)) {
    //   // กรองข้อมูลตามที่เลือก
    //   displayData = data.filter(
    //     (item) =>
    //       filteredImpactTypes.includes(item.company_id) ||
    //       filteredImpactTypes.includes(item.id),
    //   )
    // }

    return (
      <Table
        loading={isLoading}
        key={checkChangeTable}
        onRow={(record) => {
          return {
            onClick: () => eventEdit(record), // click row
          }
        }}
        columns={columns}
        dataSource={dataSource}
        onChange={onChange}
        pagination={pagination}
        showSorterTooltip={false}
      />
    )
  }

  const columns = [
    // table impactype
    {
      title: <h5>Business</h5>,
      dataIndex: 'company_code',
      ellipsis: true,
    },
    {
      title: <h5>{word['Impact_type']}</h5>,
      dataIndex: 'impact_code',
      sorter: (a, b) => a.impact_code.localeCompare(b.impact_code),
      ellipsis: true,
      ...getColumnSearchProps('impact_code'),
    },
    {
      title: <h5>{word['Local_name']}</h5>,
      dataIndex: 'local_name',
      sorter: (a, b) => a.local_name.localeCompare(b.local_name),
      ellipsis: true,
      ...getColumnSearchProps('local_name'),
    },
    {
      title: <h5>{word['English_name']}</h5>,
      dataIndex: 'english_name',
      sorter: (a, b) => a.english_name.localeCompare(b.english_name),
      ellipsis: true,
      ...getColumnSearchProps('english_name'),
    },
    {
      title: <h5>status</h5>,
      dataIndex: 'status',
      sorter: (a, b) => a.status.localeCompare(b.status),
      ellipsis: true,
      ...getColumnSearchProps('status'),
    },
  ]
  const dataSource = data.map((item) => ({
    id: item.id,
    company_code: item.company_code,
    impact_code: item.code,
    local_name: item.name,
    english_name: item.name_en,
    data: item,
    status: item.status,
  }))

  const onFinish = (value) => {
    if (stateDrawer === 'add') {
      const data = {
        company_id: value.company_code,
        code: value.impacttype_code,
        name: value.local_name_impacttype,
        name_en: value.english_name_impacttype,
        status: value.status ? 'Active' : 'Inactive',
      }
      try {
        addImpactType({
          params: data,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            setHiddenError(true)
            getResultTreeImpacttype()
            setSwitchValue(true)

            // เช็คว่ามีการเลือก All หรือไม่
            if (filteredImpactTypes.includes(0)) {
              fetchAllImpactTypeData()
            } else {
              getDataImpactype()
            }

            setVisible(false)
          } else {
            if (res.data.errorCode === '2008') {
              setWordERR(word['err_impact_code'])
            } else {
              setWordERR('error')
            }
            setHiddenError(false)
          }
        })
      } catch (error) {
        console.log(error)
      }
    } else {
      const data = {
        id: dataEdit.id,
        company_id: value.company_code,
        code: value.impacttype_code,
        name: value.local_name_impacttype,
        name_en: value.english_name_impacttype,
        status: value.status ? 'Active' : 'Inactive',
      }
      try {
        updateImpactType({
          params: data,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            setHiddenError(true)
            getResultTreeImpacttype()
            setSwitchValue(true)

            if (checkByID === true) {
              getResultImpacttypeById()
            } else {
              getDataImpactype()
            }

            setVisible(false)
          } else {
            if (res.data.errorCode === '2018') {
              setWordERR(word['err_impact_itemused'])
            } else if (res.data.errorCode === '2008') {
              setWordERR(word['err_impact_code'])
            } else {
              setWordERR('error')
            }
            setHiddenError(false)
          }
        })
      } catch (error) {
        console.log(error)
      }
    }
  }
  const onFailed = (value) => { }
  function onChange(pagination2, filters, sorter, extra) {
    if (pagination !== false) {
      setPagination((prevState) => {
        return {
          ...prevState,
          pageSize: pagination2.pageSize,
          current: pagination2.current,
        }
      })
    }
  }
  const onChangeImpactCode = (e) => {
    form.setFieldsValue({
      impacttype_code: e.target.value.replace(/\s/g, ''),
    })
  }

  // useEffect(() => {
  //   if (companyID !== undefined && !filteredImpactTypes.includes(0)) {
  //     getDataImpactype()
  //   }
  // }, [companyID])
  // add impactype
  const eventAdd = (company_id) => {
    if (company_id === 0) {
      setSwitchValue(true)
      form.setFieldsValue({
        company_code: null,
        impacttype_code: null,
        local_name_impacttype: null,
        english_name_impacttype: null,
        status: true,
      })
    } else {
      setSwitchValue(true)
      form.setFieldsValue({
        company_code: company_id,
        impacttype_code: null,
        local_name_impacttype: null,
        english_name_impacttype: null,
        status: true,
      })
    }
    setFirsttimein(false)
    setHiddenError(true)
    setVisible(true)
    setStateDrawer('add')
    setTitleDrawer('Add Stage')
  }
  // edit impactype
  const eventEdit = (data) => {
    permissionPage.update ? setDisablePage(false) : setDisablePage(true)
    const isActive = data.data.status
    setSwitchValue(isActive === 'Active')
    form.setFieldsValue({
      company_code: data.data.company_id,
      impacttype_code: data.impact_code,
      local_name_impacttype: data.local_name,
      english_name_impacttype: data.english_name,
      status: switchValue,
    })
    setFirsttimein(false)
    setHiddenError(true)
    setDataEdit(data)
    setStateDrawer('edit')
    setTitleDrawer('Edit Stage')
    setVisible(true)
  }

  const content = () => {
    if (data.length > 0) {
      return (
        <ContainerImpactype>
          <Header className="layout-button-add-normal-state">
            <div className="layout-btn-reset-add">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Button
                  onClick={() => eventAdd(companyID)}
                  icon={<PlusOutlined className="Icon-color" />}
                  className="BTN_Next"
                  hidden={permissionPage.create ? false : true}
                >
                  {word['Add_Impact_Type']}
                </Button>
                <Button
                  type="primary"
                  style={{ marginLeft: 8 }}
                  className="btn_Secondary2"
                  onClick={() => window.location.reload()}
                >
                  <RedoOutlined className="Icon-color" />
                  {word['Reset']}
                </Button>
              </div>
            </div>
          </Header>
          <Body>{renderTable()}</Body>
        </ContainerImpactype>
      )
    } else {
      return (
        <EmptyContainer className="initialstate-container">
          <img src={iconEmpty} />
          <h2>{word['Please_add_impact_type']}</h2>
          <Button
            hidden={permissionPage.create ? false : true}
            onClick={() => eventAdd(companyID)}
            icon={<PlusOutlined className="Icon-color" />}
            className="btn_Secondary2"
          >
            {word['Add_Impact_Type']}
          </Button>
        </EmptyContainer>
      )
    }
  }

  const onClose = (value) => {
    setVisible(false)
  }

  const renderButton_Drawer = () => {
    if (stateDrawer === 'add') {
      return (
        <div
          style={{
            textAlign: 'right',
          }}
        >
          <Button className="BTN_Next" onClick={form.submit}>
            {word['Save']}
          </Button>
        </div>
      )
    } else {
      return (
        <div
          style={{
            textAlign: 'right',
          }}
        >
          <Button
            hidden={permissionPage.delete ? false : true}
            className="BTN_Delete_CPF_RED"
            onClick={() => setVisibleDelete(true)}
            style={{ marginRight: 8 }}
          >
            {word['Delete']}
          </Button>
          <Button
            hidden={permissionPage.update ? false : true}
            className="BTN_Next"
            onClick={form.submit}
            type="primary"
          >
            {word['Save']}
          </Button>
        </div>
      )
    }
  }
  const modalDelete = () => {
    return (
      <DeleteImpactType
        visibleDelete={visibleDelete}
        setVisibleDelete={setVisibleDelete}
        state={'impacttype'}
        data={dataEdit}
        renderData={getResultTreeImpacttype}
        setVisibleDrawer={setVisible}
        setCheckChangeTable={setCheckChangeTable}
      />
    )
  }
  const toUpperCase = (value) => {
    form.setFieldsValue({
      impacttype_code: toUpper(value.target.value),
    })
  }
  return (
    <ImpactContainer>
      <div className="layoutmanagement-git-master">
        <div className="layout-left">
          <div style={{ marginTop: 16, marginBottom: 16, marginLeft: 16, marginRight: 16 }}>
            <FilterSearchTree
              dataItems={dataCompany}
              selectedItems={filteredImpactTypes}
              setSelectedItems={setFilteredImpactTypes}
              placeholderText={`Select ${textd}`}
              itemTypeName="Business"
              treeId="impact-type"
              excludeAllID={false}
            />
          </div>
          <Tree
            treeCompany={
              filteredTreeImpactType.length > 0 ? filteredTreeImpactType : dataTree
            }
            setLevel_ID={setLevel_ID}
            setLevel={setLevel}
            eventAdd={eventAdd}
            setCheckByID={setCheckByID}
            setCompanyID={setCompanyID}
            setCheckChangeTable={setCheckChangeTable}
            checkChangeTable={checkChangeTable}
          />
        </div>
        <div className="layout-right">{content()}</div>
      </div>

      <Modal
        maskClosable={false}
        title={<TextTitleBold>{titleDrawer}</TextTitleBold>}
        placement="right"
        onCancel={onClose}
        visible={visible}
        width={'634px'}
        footer={renderButton_Drawer()}
        destroyOnClose
        className="fix-modal"
        centered
      >
        <Form
          className="disable-page"
          form={form}
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFailed}
        >
          <fieldset disabled={disablePage}>
            <div hidden={hiddenError} style={{ marginBottom: 10 }}>
              <Alert message={wordERR} type="error" showIcon />
            </div>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  id="company_code"
                  name="company_code"
                  label={<h4>{word['Business_Code']}</h4>}
                  rules={[{ required: true, message: 'Please enter business code' }]}
                >
                  <Select
                    showSearch
                    id="select_company_code"
                    size="large"
                    placeholder="Please enter business code"
                    allowClear
                    optionFilterProp="children"
                    disabled={disablePage}
                  >
                    {dataCompany.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.code} {item.name_en}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  id="impacttype_code"
                  name="impacttype_code"
                  label={<h4>{word['Impact_Type_Code']}</h4>}
                  className="customValidation"
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter stage code',
                    },
                  ]}
                >
                  <Input
                    id="impactype_code"
                    size="large"
                    maxLength={10}
                    onChange={onChangeImpactCode}
                    onKeyUp={toUpperCase}
                    placeholder="Please enter stage code"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  id="local_name_impacttype"
                  name="local_name_impacttype"
                  label={<h4>{word['Local_Impact_Type_Name']}</h4>}
                  className="customValidation"
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter local stage name',
                    },
                  ]}
                >
                  <Input
                    id="local_name_impactype"
                    size="large"
                    placeholder="Please enter stage name"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  id="english_name_impacttype"
                  name="english_name_impacttype"
                  label={<h4>{word['English_Impact_Type_Name']}</h4>}
                  className="customValidation"
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter english stage name',
                    },
                  ]}
                >
                  <Input
                    id="english_name_impactype"
                    size="large"
                    placeholder="Please enter english stage name"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item name="status">
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: '8px' }}>Status Active:</span>
                    <Switch
                      checked={switchValue}
                      onChange={(checked) => {
                        form.setFieldsValue({ status: checked })
                        setSwitchValue(checked)
                      }}
                    ></Switch>
                  </div>
                </Form.Item>
              </Col>
            </Row>
          </fieldset>
        </Form>
        {modalDelete()}
      </Modal>
    </ImpactContainer>
  )
}
export default Impact
